import { normalize } from 'normalizr'

import { jsonPost } from '../api'
import * as auth from '../auth'

export const saveCardData = (token, cardData, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/SaveCardData`,
        {
            LAZAccountCardDetail: {
                Id: '-1',
                NickName: `${cardData.Name} ${cardData.CardType}`,
                Active: true,
                ...cardData,
            },
            Token: token,
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    )
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch()

export const removeCreditCard = (creditCard, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/SaveCardData`,
        {
            LAZAccountCardDetail: {
                Id: creditCard.id,
                ccToken: '',
                ExpDate: '',
                CardType: '',
                CardLast4: '',
                Name: '',
                NickName: '',
                CardProcessor: '',
                Active: false,
            },
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    )
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch()

export const setDefaultCreditCard = (token, creditCard, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/SaveDefaultCardData`,
        {
            LAZAccountCardDetail: {
                Id: creditCard.id,
                Active: true,
            },
            Token: token,
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    )
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch(error => {
            throw new Error(error.message)
        })
